import React, { useState } from 'react'
import {
  DialogContentText,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SaveUpdateButtons from './SaveUpdateButtons'
import PlayersAutocomplete from './PlayersAutocomplete'
import TeamSelection from './TeamSelection'
import { MATCH_HIGHLIGHT_TEAMS, SWAP_REASONS } from 'constants/match'

const AddEditReplacement = ({
  onClose,
  existingData,
  errorMinute,
  minute,
  setErrorMinute,
  participantsList,
  handleSave,
  handleUpdate,
  resetCommonFields,
}) => {
  const [scoredTeam, setScoredTeam] = useState(
    existingData && existingData.team
      ? existingData.team
      : MATCH_HIGHLIGHT_TEAMS.own
  )
  const [p1value, setP1Value] = useState(null)
  const [p2value, setP2Value] = useState(null)
  const [reason, setReason] = useState(
    existingData ? existingData.reason : SWAP_REASONS[0].key
  )
  const [resetPlayer, setResetPlayer] = useState(false)

  const resetForm = () => {
    resetCommonFields()
    setScoredTeam(MATCH_HIGHLIGHT_TEAMS.own)
    setP1Value(null)
    setP2Value(null)
    setReason(SWAP_REASONS[0].key)
    setResetPlayer(true)
  }
  const handleScoredTeam = (val) => {
    if (val === MATCH_HIGHLIGHT_TEAMS.opponent) {
      setP1Value(null)
      setP2Value(null)
    }
    setScoredTeam(val)
  }
  const save = (exit = false) => {
    if (errorMinute) return false

    if (!minute) {
      setErrorMinute(true)

      return false
    }
    const createData = {
      type: 'substitution',
      team: scoredTeam,
      reason,
      minute,
      player_1: p1value,
      player_2: p2value,
    }
    handleSave(createData).then(() => {
      resetForm()
      if (exit === true) {
        onClose()
      }
    })

    return false
  }
  const update = (highLightId) => {
    if (errorMinute) return false

    const updateData = {
      type: 'substitution',
      team: scoredTeam,
      reason,
      minute,
      player_1: p1value,
      player_2: p2value,
    }
    handleUpdate(highLightId, updateData)
    onClose()

    return false
  }

  return (
    <>
      <DialogContentText>
        <Translate id="matches.highlights.swap-heading" />
      </DialogContentText>
      <Grid item style={{ marginTop: '0.25rem' }}>
        <TeamSelection
          selectedTeam={scoredTeam}
          handleTeam={handleScoredTeam}
        />
      </Grid>
      <Grid item>
        <FormControl variant="outlined" margin="dense">
          <InputLabel id="demo-simple-select-label">
            <Translate id="matches.highlights.reason-for-substitution" />
          </InputLabel>
          <Select
            labelId="demo-simple-select-outlined-label"
            id="match-type-selected-outlined"
            value={reason}
            onChange={(event) => {
              return setReason(event.target.value)
            }}
            label={
              <Translate id="matches.highlights.reason-for-substitution" />
            }
          >
            {SWAP_REASONS.map((p) => {
              return (
                <MenuItem key={p.key} value={p.key}>
                  {p.displayValue}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Grid>
      {scoredTeam !== MATCH_HIGHLIGHT_TEAMS.opponent && (
        <>
          <Grid item>
            <PlayersAutocomplete
              setPValue={setP2Value}
              label={<Translate id="matches.highlights.new-player" />}
              savedPlayer={
                existingData && existingData.relationships?.player_2?.uuid
                  ? existingData.relationships.player_2.uuid
                  : 0
              }
              players={participantsList}
              resetPlayer={resetPlayer}
              setResetPlayer={setResetPlayer}
            />
          </Grid>
          <Grid item>
            <PlayersAutocomplete
              setPValue={setP1Value}
              label={<Translate id="matches.highlights.player-replaced" />}
              savedPlayer={
                existingData && existingData.relationships?.player_1?.uuid
                  ? existingData.relationships.player_1.uuid
                  : 0
              }
              players={participantsList}
              resetPlayer={resetPlayer}
              setResetPlayer={setResetPlayer}
            />
          </Grid>
        </>
      )}
      <SaveUpdateButtons
        save={save}
        existingData={existingData}
        update={update}
      />
    </>
  )
}
AddEditReplacement.defaultProps = {
  onClose: () => 0,
  existingData: null,
  handleSave: () => 0,
  handleUpdate: () => 0,
}
AddEditReplacement.propTypes = {
  onClose: PropTypes.func,
  handleSave: PropTypes.func,
  handleUpdate: PropTypes.func,
  participantsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  existingData: PropTypes.shape(),
  errorMinute: PropTypes.bool.isRequired,
  minute: PropTypes.number.isRequired,
  setErrorMinute: PropTypes.func.isRequired,
  resetCommonFields: PropTypes.func.isRequired,
}
export default connect(
  ({
    matches: {
      current: { id },
    },
  }) => ({
    matchId: id,
  }),
  {}
)(AddEditReplacement)
